import moment from "moment";
import Config from "../constants/config";
import ApiManager from "./ApiManager";

const GPSinaApis = {
    _defualtParams: {
        timeSpansOf: month => ({
            startTime: parseInt(moment().add(-month, "months").valueOf() / 1000),
            endTime: parseInt(moment().valueOf() / 1000)
        })
    },
    login: ({ phone }) => {
        const data = { phone };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/login', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    validateOtp: ({ code }) => {
        const data = { code };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/validateOtp', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getUser: () => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getUser').then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    createSession: ({ appID, fcmKey, platform, version }) => {
        const data = { appID, fcmKey, platform, version };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/createSession', data).then(res => {
                if (res.data.code === 1008) resolve(res.data.data);
                else reject(res);
            }).catch(err => reject(err));
        });
    },
    register: ({ firstName, lastName, userName, password, email, phone }) => {
        const data = { firstName, lastName, userName, password, email, phone };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/register', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    resendOtp: ({ }) => {
        const data = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/resendOtp', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getpin: ({ deviceID }) => {
        const data = { deviceID };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/getpin', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    logout: () => {
        const data = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/logout', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    revokePin: () => {
        const data = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/revokePin', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    generatePin: ({ expiryHours }) => {
        const data = { expiryHours };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/generatePin?expiryHours=' + expiryHours, data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getAllDevices: ({ }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getAllDevices`).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    refreshDevice: ({ deviceID }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/refreshDevice?deviceID=${deviceID}`).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getDeviceSettings: ({ deviceID }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getDeviceSettings?deviceID=${deviceID}`).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    shareDevice: ({ deviceID, email }) => {
        const data = { deviceID, email };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/shareDevice', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    unShareDevice: ({ deviceID, email }) => {
        const data = { deviceID, email };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/unShareDevice', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    updateRegistrationNo: ({ deviceID, registrationNo }) => {
        const data = { deviceID, registrationNo };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/updateRegistrationNo', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    detachDevice: ({ deviceID }) => {
        const data = { deviceID };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/detachDevice', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    attachDevice: ({ deviceID, registrationNo, vehicleOwnerName, vehicleModel, vehicleID, color, vehicleType, fuelType, mileage, chassis, engineNo }) => {
        const data = { deviceID, registrationNo, vehicleOwnerName, vehicleModel, vehicleID, color, vehicleType, fuelType, mileage, chassis, engineNo };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/attachDevice', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getLatestDeviceData: ({ deviceID }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getLatestDeviceData?deviceID=${deviceID}`).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getAllDeviceAlerts: (body) => {
        let {alarmCode,page, deviceID,startTime,endTime,timeZone,recordType} = body;
        // console.log("deviceID", deviceID,"alarmCode",alarmCode,"startTime", startTime,"endTime", endTime,"timeZone", timeZone)
        const timeSpan = GPSinaApis._defualtParams.timeSpansOf(3)
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getAllDeviceAlerts`, { deviceID , ...timeSpan,page ,alarmCode,recordType})
            .then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getUnfilteredDeviceAlerts: (body) => {
        let {deviceID,startTime,endTime} = body;
        return new Promise((resolve,reject) => {
            ApiManager.getInstance().send('GET', `/api/getUnfilteredDeviceAlerts`,{deviceID,startTime,endTime})
            .then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    clearAlerts: ({ deviceID }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/clearAlerts', { deviceID }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getAllTripDates: ({ deviceID, timeZone, page }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getAllTripDates', { deviceID, timeZone, page }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getTripHistoryReportS3: ({ deviceID, timeZone, startTime, endTime }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getTripHistoryReportS3', { deviceID, timeZone, startTime, endTime }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getParkedHistoryReport: ({ deviceID, timeZone, startTime, endTime, date, page }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getParkedHistoryReport', { deviceID, timeZone, startTime, endTime, date, page }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getMileageReport: (body) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getDailyDistance`, body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getDriverReport: (body) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getDriverAssignmentHistory`, body, "installer").then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    geTripReport: ({ deviceID, timeZone, startTime, endTime, page }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getParkedHistoryReport', { deviceID, timeZone, startTime, endTime, page }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getDeviceGeofences: ({ deviceID, page }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', '/api/getDeviceGeofences', { deviceID, page }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    addDeviceGeoFence: ({ longitude, latitude, endLongitude, endLatitude, ownerEmail, deviceID, geoFenceName }) => {
        const data = { longitude, latitude, endLongitude, endLatitude, ownerEmail, deviceID, geoFenceName };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/addDeviceGeoFence', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    updateDeviceGeoFence: ({ deviceID, geoFenceId, geoFenceName }) => {
        const data = { deviceID, geoFenceId, geoFenceName };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/updateDeviceGeoFence', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    deleteDeviceGeofence: ({ deviceID, geoFenceId }) => {
        const data = { deviceID, geoFenceId };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/deleteDeviceGeofence', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getEngineOnOffReport: ({ deviceID, startTime, endTime, timeZone, page }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getEngineOnOffReport`, { deviceID, startTime, endTime, timeZone, page }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    loginPin: ({ appVersion, email, fcmKey, isPin, pinCode }) => {
        const data = { appVersion, email, fcmKey, isPin, pinCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/loginPin', data).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    setSettings: ({ deviceId, command, data, pinCode }) => {
        const body = { deviceId, command, data, pinCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/setSettings', body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    updateAvatar: ({ avatar }) => {
        const body = { avatar };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", '/api/updateAvatar', body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },


    createSecurityPin: ({ pinCode }) => {
        const body = { pinCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/createSecurityPin", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    validateSecurityPinOTP: ({ code }) => {
        const body = { code };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/validateSecurityPinOTP", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    updateSecurityPin: ({ pinCode, NewPinCode }) => {
        const body = { pinCode, NewPinCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/updateSecurityPin", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    resendSecurityPinOtp: () => {
        const body = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/resendSecurityPinOtp", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    deleteUserAccount: ({ pinCode }) => {
        const body = { pinCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/deleteUserAccount", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    checkSecurityPinExist: () => {
        const body = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/checkSecurityPinExist", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    forgotSecurityPin: () => {
        const body = {};
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/forgotSecurityPin", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getCompanyInfo: () => {
        const body = { appID: Config.appType };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/getCompanyInfo", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getExpiredDevices: () => {
        const body = { appID: Config.appType };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/getExpiredDevices", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getNotifications: ({ deviceID }) => {
        const body = { deviceID };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/getNotifications", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    toggleNotifications: ({ deviceID, alarmCode }) => {
        const body = { deviceID, alarmCode };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/toggleNotification", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    changeDeviceOwnership: (body) => {
        // const body = { deviceID, pinCode, email, phone };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/changeDeviceOwnership", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getClientAccounts: ({ searchClause, page = 1 }) => {
        const body = { searchClause, page };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("GET", "/api/getClientAccounts", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    changeAccount: ({ userId }) => {
        const body = { userId };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/changeAccount", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    setMobileInfo: ({ apiLevel = undefined, applicationName = undefined, buildId = undefined, brand = undefined, buildNumber = undefined, bundleId = undefined, carrier = undefined, deviceId = undefined, deviceType = undefined, deviceName = undefined, firstInstallTime = undefined, ipAddress = undefined, installerPackageName = undefined, macAddress = undefined, manufacturer = undefined, model = undefined, phoneNumber = undefined, systemName = undefined, systemVersion = undefined, totalMemory = undefined, uniqueId = undefined, usedMemory = undefined, version = undefined, locationEnabled = undefined, tablet = undefined }) => {
        const body = { apiLevel, applicationName, buildId, brand, buildNumber, bundleId, carrier, deviceId, deviceType, deviceName, firstInstallTime, ipAddress, installerPackageName, macAddress, manufacturer, model, phoneNumber, systemName, systemVersion, totalMemory, uniqueId, usedMemory, version, locationEnabled, tablet };
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send("POST", "/api/setMobileInfo", body).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
    getDeviceSettingFromServer: ({ softwareVersion }) => {
        return new Promise((resolve, reject) => {
            ApiManager.getInstance().send('GET', `/api/getSoftwareVersion`, { softwareVersion }).then(res => {
                resolve(res);
            }).catch(err => reject(err));
        });
    },
}

export default GPSinaApis;